import '../styles/PageGlobal.css';
import './AdresseListLivClientPage.css';
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AdresseService } from '../services/AdresseService.js';

export default function AdresseListLivClientPage() {
  const navigate = useNavigate();
  const [adresses, setAdresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAdresses = useCallback(async () => {
    const adresseService = new AdresseService();
    setLoading(true);
    setError(null);
    try {
      const data = await adresseService.getAllAdresses();
      // Filtrer pour ne garder que les adresses liées à un client
      const clientAdresses = data.filter(a => a.clientId !== null);
      setAdresses(clientAdresses);
    } catch (err) {
      console.error(err);
      setError(err.message || 'Erreur lors du chargement des adresses');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAdresses(); }, [fetchAdresses]);

  if (loading) return <div>Chargement…</div>;
  if (error) return <div className="adresse-error">{error}</div>;

  return (
    <div className="containerMain adresse-container">
      <h1 className="adresse-title">Liste des adresses de livraison du Client</h1>

      <div className="adresse-table-wrapper">
        <table className="adresse-table">
          <thead>
            <tr>
              <th>N</th>
              <th>ID Client</th>
              <th>Type</th>
              <th>Adresse 1</th>
              <th>Adresse 2</th>
              <th>Code Postal</th>
              <th>Ville</th>
              <th>Pays</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {adresses.map((a, index) => (
              <tr key={a.id}>
                <td>{index + 1}</td>
                <td className="adresse-client">{a.clientId || 'N/A'}</td> 
                <td>{a.type}</td>
                <td>{a.adresse1 || ''}</td>
                <td>{a.adresse2 || ''}</td>
                <td>{a.codePostal || ''}</td>
                <td>{a.ville || ''}</td>
                <td>{a.pays || ''}</td>
                <td className="adresse-action-cell">
                  <button className="adresse-btn adresse-btn-yellow" onClick={() => navigate(`/adresse/edit/client/${a.id}`)}>
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="adresse-add-btn">
        <button className="adresse-btn adresse-btn-green" onClick={() => navigate('/adresse/new/client')}>
          Ajouter une adresse
        </button>
      </div>
    </div>
  );
}